import { render, staticRenderFns } from "./ItemsToBuy.html?vue&type=template&id=233d025c&scoped=true&"
import script from "./ItemsToBuy.vue?vue&type=script&lang=js&"
export * from "./ItemsToBuy.vue?vue&type=script&lang=js&"
import style0 from "./ItemsToBuy.scss?vue&type=style&index=0&id=233d025c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233d025c",
  null
  
)

export default component.exports